export default __webpack_public_path__ + "static/media/pedro-lastra.18bf9c8c.jpg";